import React from "react";
import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

// Reusable "what it means / why it matters" explainer used across the product.
export const TermExplainer = ({ term, what, why, className = "", testId }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        type="button"
        data-testid={testId}
        className={`inline-flex items-center justify-center text-zinc-500 transition-colors hover:text-amber-400 ${className}`}
        aria-label={`What is ${term}`}
      >
        <Info className="h-3.5 w-3.5" strokeWidth={1.75} />
      </button>
    </PopoverTrigger>
    <PopoverContent
      side="top"
      align="start"
      className="z-50 w-72 border border-white/15 bg-[#181B21] p-3.5 text-zinc-200 shadow-2xl"
    >
      <p className="mb-1 flex items-center gap-1.5 font-mono text-[11px] font-semibold uppercase tracking-wider text-white">
        {term}
      </p>
      <p className="text-xs leading-relaxed text-zinc-300">{what}</p>
      {why && (
        <p className="mt-2 border-t border-white/10 pt-2 text-[11px] font-medium leading-relaxed text-amber-300/90">
          Why it matters — {why}
        </p>
      )}
    </PopoverContent>
  </Popover>
);
